import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const DesignationForm=React.lazy(() => import('./Form'));
const DesignationTable=React.lazy(() => import('./DesignationTable'));
export const DesignationConfigs = [
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/designation/create',
    element: <DesignationForm />,
  },
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/designation/table',
    element: <DesignationTable />,
  },

];
